import * as React from "react";
import { cn } from "@/lib/utils";

interface ToggleGroupProps<T extends string> {
  value: T;
  onValueChange: (value: T) => void;
  options: Array<{ value: T; label: string }>;
  disabled?: boolean;
  className?: string;
}

export function ToggleGroup<T extends string>({
  value,
  onValueChange,
  options,
  disabled = false,
  className,
}: ToggleGroupProps<T>) {
  return (
    <div
      className={cn(
        "inline-flex rounded-lg bg-muted p-1 gap-1",
        className
      )}
      role="group"
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => !disabled && onValueChange(option.value)}
          disabled={disabled}
          className={cn(
            "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-all",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
            "disabled:pointer-events-none disabled:opacity-50",
            value === option.value
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:bg-background/50 hover:text-foreground"
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

